<template>
  <div class="document-content">
    <transition-group name="list" tag="ul">
      <li class="doc-head" key="header" v-if="documents && documents.length > 0">
        <div class="doc-ext"></div>
        <div class="doc-name">{{ this.$root.contentText.name }}</div>
        <div class="doc-size">{{ this.$root.contentText.size }}</div>
        <div class="doc-date">{{ this.$root.contentText.date }}</div>
      </li>
      <li v-bind:key="document.id" v-for="document in documents">
        <div class="doc-ext" v-if="document.extension"><img :src="getPicto( document.extension )" alt=""></div>
        <div class="doc-name" v-if="document.name"><a :href="document.url" target="_blank">{{ document.name }}</a></div>
        <div class="doc-size" v-if="document.size">{{ document.size | formatSize }}</div>
        <div class="doc-date" v-if="document.date">{{ document.date }}</div>
      </li>
    </transition-group>

    <div class="no-document" v-if="this.$root.filteredDocuments.length === 0">
      {{this.$root.contentText.nop}}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'documentContent',
    computed: {
      documents() {
        return this.$root.filteredDocuments ? this.$root.filteredDocuments : this.$root.documents
      },
    },
    methods: {
      getPicto(extension) {
        if (extension !== 'pdf' && extension !== 'docx') {

          return require(`@/assets/file.png`)
        } else if (extension === 'docx' || extension === 'doc') {
          extension = 'word'
        }

        return require(`@/assets/${extension}.png`)
      }
    },
    filters: {
      formatSize(value) {
        var thresh = 1000;
        if (Math.abs(value) < thresh) {
          return value + ' B';
        }
        var units = ['Ko', 'Mo', 'Go', 'To', 'Po', 'Eo', 'Zo', 'Yo'];
        var u = -1;
        do {
          value /= thresh;
          ++u;
        } while (Math.abs(value) >= thresh && u < units.length - 1);
        return value.toFixed(1) + ' ' + units[u];
      }
    }
  }
</script>

<style lang="scss" scoped>

  ul {
    list-style: none;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    padding: 0;
    margin: 0;

    li {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      color: #4678A2;
      transition: all 0.1s ease-in-out;
      width: 100%;
      font-size: 1.6rem;
      overflow: visible;

      @media (max-width: 767px) {
        font-size: 1.8rem;
        justify-content: flex-start;
      }

      & > div {
        padding: 1rem;
      }

      &.doc-head {
        @media (max-width: 767px) {
          display: none;
        }

        > div {
          color: #23201F;
          padding-top: 0;
          text-transform: uppercase;
          font-size: 1.2rem;
          letter-spacing: 1.5px;
        }
      }

      .doc-ext {
        flex-basis: 5%;
      }

      .doc-name {
        flex-grow: 1;
        flex-basis: 65%;
        color: #23201F;

        a {
          text-decoration: none;
          color: #23201F;
          transition: all 0.1s ease-in-out;

          &:hover {
            color: #4678A2;
          }
        }
      }

      .doc-size {
        flex-basis: 15%;
        color: #727272;
      }

      .doc-date {
        flex-basis: 15%;
        color: #727272;
      }

      @media (max-width: 767px) {
        .doc-size, .doc-date {
          display: none;
        }

        .doc-ext {
          flex-basis: 12%;
          flex-shrink: 0;
        }

        .doc-name {
          flex-grow: 1;
          flex-basis: 85%;
          font-size: 1.4rem;
          padding: 0.5rem 1rem;
        }
      }
    }
  }

  .list-enter-active, .list-leave-active {
    transition: all 0.5s;
  }

  .list-enter, .list-leave-to {
    opacity: 0;
    transform: translateX(5px);
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
